/**
 * Costanti per il sistema pubblicitario
 * 
 * @since v3.0.0 - Nuovo sistema ads modulare
 */

/**
 * Tipi di ad supportati
 */
export const AD_TYPES = {
  PREROLL: 'preroll',   // Prima del contenuto
  MIDROLL: 'midroll',   // Durante il contenuto
  POSTROLL: 'postroll'  // Dopo il contenuto
};

/**
 * Sorgenti ad supportate
 */
export const AD_SOURCES = {
  STATIC: 'static',     // File audio statico
  GAM: 'gam',           // Google Ad Manager (VAST)
  SPREAKER: 'spreaker', // Spreaker (episodio con ads già inclusi)
  CUSTOM: 'custom'      // Custom provider (espandibile)
};

/**
 * Tipi di posizione per midroll
 */
export const POSITION_TYPES = {
  PERCENTAGE: 'percentage',  // Percentuale del contenuto (0-100)
  SECONDS: 'seconds'         // Secondi assoluti dall'inizio
};

/**
 * Stati di un ad
 */
export const AD_STATES = {
  PENDING: 'pending',       // In attesa di riproduzione
  LOADING: 'loading',       // Caricamento in corso
  PLAYING: 'playing',       // In riproduzione
  COMPLETED: 'completed',   // Completato con successo
  SKIPPED: 'skipped',       // Skippato dall'utente
  ERROR: 'error',           // Errore durante caricamento/riproduzione
  FALLBACK: 'fallback'      // Fallback a sorgente alternativa
};

/**
 * Eventi ads custom
 */
export const AD_EVENTS = {
  AD_START: 'sasha:adstart',           // Inizia un ad
  AD_COMPLETE: 'sasha:adcomplete',     // Ad completato
  AD_SKIPPED: 'sasha:adskipped',       // Ad skippato
  AD_ERROR: 'sasha:aderror',           // Errore ad
  AD_PROGRESS: 'sasha:adprogress',     // Progresso ad (per countdown)
  ALL_ADS_PLAYED: 'sasha:alladsplayed' // Tutti gli ads completati
};

/**
 * Configurazione di default per frequency capping
 */
export const DEFAULT_FREQUENCY_CAP = {
  enabled: false,           // Disabilitato di default
  storage: 'session',       // 'session' | 'local' | 'none'
  maxPlays: 1,              // Numero massimo di riproduzioni
  timeWindow: null,         // Finestra temporale (ms), null = per sessione
  key: 'sasha-ad-frequency' // Chiave localStorage/sessionStorage
};

